import { HttpErrorResponse } from '@angular/common/http';

import { createAction, props } from '@ngrx/store';

import { OfferData, OfferFull, Position } from '@recruitee/http-types';

import { OfferScope } from '../../types';
import { StatusChangeType } from './../../types';

const namespace = 'TalentPools';

const getActionType = (name: string) => `[${namespace}] ${name}`;

const actions = {
  follow: createAction(
    getActionType('follow'),
    props<{ payload: { id: number; scope: OfferScope } }>(),
  ),
  unfollow: createAction(
    getActionType('unfollow'),
    props<{ payload: { id: number; scope: OfferScope } }>(),
  ),
  followSuccess: createAction(getActionType('followSuccess')),
  followFailed: createAction(
    getActionType('followFailed'),
    props<{ payload: { error: HttpErrorResponse; id: number } }>(),
  ),
  unfollowSuccess: createAction(getActionType('unfollowSuccess')),
  unfollowFailed: createAction(
    getActionType('unfollowFailed'),
    props<{ payload: { error: HttpErrorResponse; id: number } }>(),
  ),
  duplicate: createAction(getActionType('duplicate'), props<{ payload: { id: number } }>()),
  duplicateSuccess: createAction(
    getActionType('duplicateSuccess'),
    props<{ payload: { offer: OfferFull } }>(),
  ),
  duplicateFailed: createAction(
    getActionType('duplicateFailed'),
    props<{ payload: { id: number; error: HttpErrorResponse & { errorFields: any } } }>(),
  ),
  changeStatus: createAction(
    getActionType('changeStatus'),
    props<{ payload: { id: number; status: StatusChangeType } }>(),
  ),
  changeStatusSuccess: createAction(
    getActionType('changeStatusSuccess'),
    props<{ payload: { offer: OfferFull } }>(),
  ),
  changeStatusFailed: createAction(
    getActionType('changeStatusFailed'),
    props<{ payload: { id: number; error: HttpErrorResponse & { errorFields: any } } }>(),
  ),
  create: createAction(getActionType('create'), props<{ payload: { offer: OfferData } }>()),
  createSuccess: createAction(
    getActionType('createSuccess'),
    props<{ payload: { data: OfferFull } }>(),
  ),
  createFailed: createAction(
    getActionType('createFailed'),
    props<{ payload: { error: HttpErrorResponse & { errorFields: any } } }>(),
  ),
  update: createAction(
    getActionType('update'),
    props<{ payload: { offer: OfferData & { id: number } } }>(),
  ),
  updateSuccess: createAction(
    getActionType('updateSuccess'),
    props<{ payload: { data: OfferFull } }>(),
  ),
  updateFailed: createAction(
    getActionType('updateFailed'),
    props<{ payload: { id: number; error: HttpErrorResponse & { errorFields: any } } }>(),
  ),
  removeOne: createAction(getActionType('removeOne'), props<{ payload: { id: number } }>()),
  removeOneSuccess: createAction(
    getActionType('removeOneSuccess'),
    props<{ payload: { id: number } }>(),
  ),
  removeOneFailed: createAction(
    getActionType('removeOneFailed'),
    props<{ payload: { id: number; error: HttpErrorResponse } }>(),
  ),
  updatePositions: createAction(getActionType('updatePositions'), props<{ payload: Position[] }>()),
  updatePositionsSuccess: createAction(getActionType('updatePositionsSuccess')),
  updatePositionsFailed: createAction(
    getActionType('updatePositionsFailed'),
    props<{ payload: { error: HttpErrorResponse } }>(),
  ),
};

export { actions as TalentPoolsActions };
